// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__iDz-x","alert":"SettungsInbox_alert__1GW75"};